import { render, staticRenderFns } from "./UiSuccess.vue?vue&type=template&id=8f965008&scoped=true&"
import script from "./UiSuccess.vue?vue&type=script&lang=js&"
export * from "./UiSuccess.vue?vue&type=script&lang=js&"
import style0 from "./UiSuccess.vue?vue&type=style&index=0&id=8f965008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f965008",
  null
  
)

component.options.__file = "UiSuccess.vue"
export default component.exports